import { LocalizerHelper } from "../../helpers/localizerHelper";
import { formatDitsMenuItemPriceV2, GroupItem } from "../../helpers/ditsMenuItemHelper";
import { MenuItemAddOn, MenuItemOption } from "../../models";
import { Button } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import AskDeleteItems from "../ask_delete_items/AskDeleteItems";
import React from "react";
import { deleteItemFromSession } from "../../features/session/session.service";

interface Props {
  canDelete: boolean;
  groupItem: GroupItem;
}

export const SessionMenuItemsRow = ({ canDelete, groupItem }: Props) => {
  const [showDelete, setShowDelete] = React.useState(false);

  if(!groupItem) return null;

  const menuItem = groupItem.item;
  const qty = groupItem.qty;
  const toShowMinus = menuItem.minus.map((item) => LocalizerHelper.localized(item, ['title', 'name'])).join(',');


  const _deleteSessionItem = () => {
    if(groupItem.items.length > 0){
      const item = groupItem.items[0];
      deleteItemFromSession(item);
    }
    setShowDelete(false);
  }


  return <div key={`menu-item-${menuItem.ref}`}>
    <div className="row menu-item-row">
      <div className="col-2 text-left">
        <span className="menu-item-qty-label">x {qty}</span>
      </div>
      <div className="col-5 text-left">
        <span className="menu-item-name-label" key={"label"}>{LocalizerHelper.localized(menuItem, ['name'])}</span>
        {menuItem.add_ons.map((addOn: MenuItemAddOn) => {
          return addOn.options.map((option: MenuItemOption, ind: number) => {
            const label: string = LocalizerHelper.localized(option, ['name', 'title'])?.trim() ?? "";
            return (<span className="menu-item-addons-label" id={ind.toString()}>+ {label} </span>);
          })
        })}
        {menuItem.minus.length > 0 && 
          <span className="menu-item-minus-label">- {toShowMinus}</span>
        }
        {menuItem.note.length > 0 &&
          <span className="menu-item-notes-label">{menuItem.note}</span>
        }
      </div>
      <div className="col-3 text-right">
          <span className="menu-item-price-label">{formatDitsMenuItemPriceV2(menuItem, qty)}</span>
      </div>   
      <div className="col-2 text-left">
          {canDelete &&
            <Button 
              className='delete-action-button'
              onClick={() => setShowDelete(true)}
            >
              <Close fontSize="small" htmlColor={"#ffffff"}/>
            </Button>
          }
      </div>
    </div>
    {showDelete && <AskDeleteItems allowCallback={_deleteSessionItem} denyCallback={() => setShowDelete(false)}/>}
  </div>
};